<template>
  <ul class="zt-breadcrumbs items-baseline flex flex-wrap m-0">
    <li v-for="(item, index) in items" :key="index" :class="{ 'zt-breadcrumbs--disabled': item.disabled }"
      class="zt-breadcrumbs--item items-center inline-flex cursor-default">
      <router-link :to="item.to" class="zt-breadcrumbs--item__link">{{
        textTruncate(item.text)
      }}</router-link>
      <span v-if="!item.disabled">
        <span v-if="icon" class="px-2 text-zt-dark-300">
          <zt-icon :name="icon" />
        </span>
        <span v-else class="px-3 text-zt-dark-300">
          {{ separator }}
        </span>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ztBreadcrumbs',
  inheritAttrs: false,
}
</script>


